var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "items" },
    _vm._l(_vm.items, function (item, index) {
      return _c("div", { key: index, staticClass: "item" }, [
        _c("div", { staticClass: "item-element" }, [
          _c("div", { staticClass: "item-image" }, [
            _c("img", { attrs: { src: item.image.filepath } }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item-element cart-item-content" }, [
          _c("div", { staticClass: "item-sub-element" }, [
            item.subTitle
              ? _c("div", { staticClass: "item-subtitle" }, [
                  _vm._v("\n          " + _vm._s(item.subTitle) + "\n        "),
                ])
              : _vm._e(),
            _vm._v(" "),
            item.title
              ? _c("div", { staticClass: "item-title" }, [
                  _c("h5", [_vm._v(_vm._s(item.title))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            item.description
              ? _c("div", { staticClass: "item-description" }, [
                  _vm._v(
                    "\n          " + _vm._s(item.description) + "\n        "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }